<template>
  <div id="special-planned-paper-add">
    <ipub-model :title="'Edit Planned Paper'"
                width="900px"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel">
      <ipub-form ref="planned-paper-add-form"
                 :model="params"
                 :rules="rules">
        <ipub-form-item prop="name"
                        label="Authors’ Name">
          <ipub-editor :height="150"
                       v-model="params.name" />
        </ipub-form-item>
        <ipub-row :gutter="20">
          <ipub-col :span="6">
            <ipub-form-item prop="affiliation"
                            label="Affiliation">
              <ipub-input placeholder="Affiliation"
                          v-model.trim="params.affiliation" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="6">
            <ipub-form-item prop="email"
                            label="Email">
              <ipub-input placeholder="Email"
                          v-model.trim="params.email" />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-form-item prop="title"
                        label="Title">
          <ipub-editor :height="150"
                       v-model="params.title" />
        </ipub-form-item>
        <ipub-form-item prop="summary"
                        label="Abstract">
          <ipub-editor :height="300"
                       v-model="params.summary" />
        </ipub-form-item>
      </ipub-form>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import help from '../../../../utils/help'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      params: {},
      rules: {},
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      journalId: 'getJournalId',
      domain: 'getDomain',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {}
      } else {
        this.params = Object.assign(this.params, this.inputData)
      }
    }
  },
  mounted () {
    this.getRules()
  },
  methods: {
    async confirm () {
      const flag = this.$refs['planned-paper-add-form'].validate()
      if (flag) {
        this.params.titleText = help.delHtmlTag(this.params.title)
        this.params.summaryText = help.delHtmlTag(this.params.summary)
        this.params.nameText = help.delHtmlTag(this.params.name)
        this.$message.success({ title: 'Success', content: 'This Planned Paper has been saved!' })
        this.$emit('confirm', this.params)
      }
    },
    preview () {

    },
    cancel () {
      this.$emit('cancel')
    },
    getRules () {
      this.rules = {
        name: [
          {
            required: true,
            message:
              'Authors’ Name' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        title: [
          {
            required: true,
            message:
              'Title' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        email: [
          {
            type: 'email',
            message: this.LANGUAGE[this.language].enterCorrent + 'Email'
          },
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
